export type { ISearchRequestParamsOmitCountry } from "src/api/client/extended-search.api.types";

export const SearchQueryParams = {
    SearchTerm: "searchTerm",
    SortDirection: "sortOrder",
    SortByRanking: "sortBy",
    IsInvestable: "investable",
    IsAtInvestable: "austrianLicenseOnly",
    IsChInvestable: "swissLicenseOnly",
    WikifoliosWithLeverageProducts: "leverageProductsOnly",
    WikifoliosWithoutLeverageProducts: "withoutLeverageProductsOnly",
    Tags: "tags",
    BrokerIds: "brokers",
    Caller: "caller",
    View: "view",
} as const;
export type TSearchQueryParams = (typeof SearchQueryParams)[keyof typeof SearchQueryParams];
